type Config = {
  theme: 'christmas' | 'easter';
  year: number;
  fakeDates: boolean;
  feedbackUrl: string;
};

const parseTheme = (theme: string | null) => {
  if (theme == null || (theme !== 'christmas' && theme !== 'easter')) {
    return;
  }
  return theme;
};

const parseYear = (urlYear: string | null, defaultYear: string) => {
  const year = urlYear ?? defaultYear;
  const parsed = Number.parseInt(year);
  if (!Number.isFinite(parsed))
    throw new Error(`parsed year is not a number: ${parsed}`);
  return parsed;
};

const search = new URLSearchParams(window.location.search);

export const config: Config = {
  theme: parseTheme(search.get('theme')) ?? import.meta.env.VITE_THEME,
  year: parseYear(search.get('year'), import.meta.env.VITE_YEAR),
  feedbackUrl: import.meta.env.VITE_FEEDBACK_URL,
  fakeDates:
    (search.get('fakeDates') ?? import.meta.env.VITE_FAKE_DATES) === 'true',
};

export const isFlagSetInLocalStorage = (
  key: 'pin-nuts-debug-analytics' | 'pin-nuts-debug-sentry'
): boolean => {
  try {
    return localStorage.getItem(key)?.toLowerCase() === 'true';
  } catch (e) {
    return false;
  }
};
